export enum Role {
    user,
    manager,
    administrator
}

export const RoleName = new Map<number, string>([
    [Role.user, 'User'],
    [Role.manager, 'Manager'],
    [Role.administrator, 'Admin']
]);


export const NameToRole = new Map<string, Role>([
    ['User', Role.user],
    ['Manager', Role.manager],
    ['Admin', Role.administrator],
]);
